import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { isMerakiAdminUser } from './meraki-admin.util';

@Injectable({
  providedIn: 'root',
})
export class TpRoleGuard implements CanActivate {
  constructor(private router: Router, private toastr: ToastrService) { }

  private isMerakiUser(): boolean {
    const username = localStorage.getItem('username') ?? '';
    return username === 'Meraki - Operations';
  }

  private isMerakiAdmin(): boolean {
    return isMerakiAdminUser();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    const targetUrl = state.url.split('?')[0];

    // Technical Performance Dashboard:
    if (targetUrl.includes('vp-tp-dashboard')) {
      return true;
    }

    // Digital Twin Comparison: Only Meraki Admin
    if (targetUrl.includes('vp-dt-comparison')) {
      if (!this.isMerakiAdmin()) {
        this.toastr.warning(
          'Digital Twin Comparison is restricted to Meraki Administrators.',
          'Access Restricted'
        );
        return this.router.parseUrl(this.isMerakiUser() ? '/vp-tp-dashboard' : '/vp-graphs');
      }
      return true;
    }

    // Report Desk: Only Meraki Admin
    if (targetUrl.includes('report-desk')) {
      if (!this.isMerakiAdmin()) {
        this.toastr.warning(
          'Report Desk is restricted to Meraki Administrators.',
          'Access Restricted'
        );
        return this.router.parseUrl('/home');
      }
      return true;
    }

    // Live Fuel Model: Only Meraki Users (Meraki Operations & Meraki Admin), not clients
    if (targetUrl.includes('vp-voyage-series')) {
      if (!this.isMerakiUser()) {
        this.toastr.warning(
          'Dynamic Fuel Model is currently available for internal Meraki operations only.',
          'Access Restricted'
        );
        return this.router.parseUrl('/vp-graphs');
      }
      return true;
    }

    return true;
  }
}
